// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../shared/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2710%27 height=%2717%27 viewBox=%270 0 10 17%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M1 0.5L9 8.5L1 16.5%27 stroke=%27black%27 stroke-opacity=%270.25%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M7.0914 5.99919L11.7789 0.411694C11.8575 0.318836 11.7914 0.177765 11.67 0.177765H10.245C10.161 0.177765 10.0807 0.215265 10.0253 0.279551L6.15926 4.88848L2.29319 0.279551C2.23962 0.215265 2.15926 0.177765 2.07355 0.177765H0.648547C0.527118 0.177765 0.461047 0.318836 0.539618 0.411694L5.22712 5.99919L0.539618 11.5867C0.522017 11.6074 0.510726 11.6327 0.507084 11.6596C0.503442 11.6866 0.507602 11.714 0.519071 11.7386C0.53054 11.7632 0.548836 11.784 0.571786 11.7986C0.594737 11.8131 0.621378 11.8208 0.648547 11.8206H2.07355C2.15748 11.8206 2.23783 11.7831 2.29319 11.7188L6.15926 7.10991L10.0253 11.7188C10.0789 11.7831 10.1593 11.8206 10.245 11.8206H11.67C11.7914 11.8206 11.8575 11.6796 11.7789 11.5867L7.0914 5.99919Z%27 fill=%27%23FF4D4F%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Report_previewTable__\\+98VX {
	& table, & .ant-table {
		border-radius: 0;
	}

	& .ant-table-tbody .ant-table-row {
		background-color: #D9D8D8;

		& > td {
			border-bottom-color: rgba(0,0,0, 0.06);
		}
	}

	& th.ant-table-cell {
		position: relative;

		&:not(:last-child) {
			& .Report_headerText__Lta6D {
				border-right: 1px solid rgba(0,0,0, 0.06);
			}
		}
	}
}

.Report_actionIcon__AHqCi {
  display: flex;
  cursor: pointer;
}

.Report_actionsWrapper__eYcO9 {
  display: flex;
  gap: 8px;
  justify-content: space-between;
  
  @media (min-width: 576px) {
    justify-content: flex-end;
    gap: 16px;
  }
}

.Report_formItem__AVISn {
  display: flex;
  flex-direction: column;
  gap: 5px;
  
  @media (min-width: 576px) {
    flex-direction: row;
    align-items: center;
  }

  label {
    white-space: nowrap;
    text-align: left;
    flex-shrink: 0;

    @media (min-width: 576px) {
      min-width: 100px;
    }

    @media (min-width: 992px) {
      min-width: 1px;
    }
  }

  .ant-form-item {
    width: 100%;
    margin-bottom: 0;
  }
}

.Report_headerText__Lta6D {
	display: block;
	font-weight: 500;
}

.Report_reportTitle__3oFxM {
  padding-top: 20px;
}

.Report_reportFormItem__ylDGF {
  & .ant-form-item-row {
    width: 100%;
  }
}

.Report_buttonsHolder__aSbOr {
  display: flex;
  justify-content: flex-start;
}

.Report_inlineFormItem__wvsFs {
  & > .ant-row {
    flex-direction: column;
    
    @media (min-width: 576px) {
      flex-direction: row !important;
      flex-wrap: nowrap;
      align-items: center;
      gap: 16px;
    }
  }

  & .ant-form-item-label {
    flex-shrink: 0;
  }
}

.Report_uploadCsv__5QV9h {
  & .ant-form-item-control-input-content {
    flex: 0 1;
  }
}

.Report_stepsHolder__lWSzh {
  display: flex;
  gap: 20px;
  padding-bottom: 20px;
  margin-bottom: 20px;
  flex-direction: column;

  @media (min-width: 1024px) {
    flex-direction: row;
  }
}

.Report_stepItem__E7eq- {
  flex: 0 1 auto;
  position: relative;
  display: flex;
  text-align: left;
  gap: 8px;

  &:not(:last-child) {
    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 8px;
      height: 16px;
      bottom: 0;
      left: 50%;
      transform: rotate(90deg) translateX(-50%);
      font-size: 30px;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;

      @media (min-width: 1024px) {
        top: 50%;
        left: auto;
        right: -17px;
        transform: rotate(0) translate(0, -50%);
      }
    }
  }

  &.Report_current__fBpFV {
    .Report_stepNumber__BJO-k {
      background-color: #1890FF;
      border-color: #1890FF;
      color: #fff;
    }
  }

  &.Report_future__U-l\\+v {
    opacity: 0.45;
  }

  &.Report_past__47nPY:not(.Report_withError__8XVAK) {
    opacity: 0.45;
    .Report_stepNumber__BJO-k {
      background-color: #1890FF;
      color: #fff;
    }

  }

  &.Report_withError__8XVAK {
    .Report_stepNumber__BJO-k {
      text-indent: -9999999px;

      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
      background-repeat: no-repeat;
      background-position: center center;
      background-size: 12px;
      border-color: #FF4D4F;
    }

    .Report_stepText__abbfG {
      opacity: 0.45;
    }
  }

  @media (min-width: 576px) {
    padding: 0 40px 20px 0;
  }

  @media (min-width: 1024px) {
    padding: 0 40px;
  }
}

.Report_stepNumber__BJO-k {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #000;
  flex-shrink: 0;
} 

.Report_stepTitle__\\+0zlS {
  font-size: 16px;
  line-height: 1.5;
  margin: 4px 0;
  font-weight: normal;
}

.Report_stepText__abbfG {
  font-size: 14px;
  line-height: 1.6;
}

.Report_upload__r969- {
  display: flex;
}

.Report_uploadCsv__5QV9h {
  & .ant-upload {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 8px;

    @media (min-width: 576px) {
      flex-direction: row;
    }

    & a {
      white-space: nowrap;
      font-weight: 500;
    }
  }
}

.Report_previewFileName__EHc-z {
  display: flex;
  gap: 5px;
  margin-bottom: 10px;

  & svg {
    fill: rgba(0, 0, 0, 0.45);
  }

  & .anticon {
    flex-shrink: 0;
  }

  & .Report_fileName__iOnAU {
    color: #1890FF;
  }
}

.Report_importTable__jSKMm {
  & table {
    min-width: 1180px !important;
  }

  & .ant-table-cell {
    & .ant-table-column-title {
      white-space: nowrap;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Report/Report.module.css"],"names":[],"mappings":"AAAA;CACC;EACC,gBAAgB;CACjB;;CAEA;EACC,yBAAyB;;EAEzB;GACC,sCAAsC;EACvC;CACD;;CAEA;EACC,kBAAkB;;EAElB;GACC;IACC,yCAAyC;GAC1C;EACD;CACD;AACD;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,8BAA8B;;EAE9B;IACE,yBAAyB;IACzB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;;EAER;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;;IAEd;MACE,gBAAgB;IAClB;;IAEA;MACE,cAAc;IAChB;EACF;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;;IAEtB;MACE,8BAA8B;MAC9B,iBAAiB;MACjB,mBAAmB;MACnB,SAAS;IACX;EACF;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,SAAO;EACT;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;;EAEtB;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,QAAQ;;EAER;IACE;MACE,WAAW;MACX,kBAAkB;MAClB,cAAc;MACd,UAAU;MACV,YAAY;MACZ,SAAS;MACT,SAAS;MACT,yCAAyC;MACzC,eAAe;MACf,yDAAoO;MACpO,4BAA4B;MAC5B,kCAAkC;MAClC,wBAAwB;;MAExB;QACE,QAAQ;QACR,UAAU;QACV,YAAY;QACZ,uCAAuC;MACzC;IACF;EACF;;EAEA;IACE;MACE,yBAAyB;MACzB,qBAAqB;MACrB,WAAW;IACb;EACF;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb;MACE,yBAAyB;MACzB,WAAW;IACb;;EAEF;;EAEA;IACE;MACE,uBAAuB;;MAEvB,yDAAi5B;MACj5B,4BAA4B;MAC5B,kCAAkC;MAClC,qBAAqB;MACrB,qBAAqB;IACvB;;IAEA;MACE,aAAa;IACf;EACF;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,QAAQ;;IAER;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;MACnB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;;EAEnB;IACE,yBAAyB;EAC3B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;AACF","sourcesContent":[".previewTable {\n\t& table, & :global(.ant-table) {\n\t\tborder-radius: 0;\n\t}\n\n\t& :global(.ant-table-tbody .ant-table-row) {\n\t\tbackground-color: #D9D8D8;\n\n\t\t& > td {\n\t\t\tborder-bottom-color: rgba(0,0,0, 0.06);\n\t\t}\n\t}\n\n\t& :global(th.ant-table-cell) {\n\t\tposition: relative;\n\n\t\t&:not(:last-child) {\n\t\t\t& .headerText {\n\t\t\t\tborder-right: 1px solid rgba(0,0,0, 0.06);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.actionIcon {\n  display: flex;\n  cursor: pointer;\n}\n\n.actionsWrapper {\n  display: flex;\n  gap: 8px;\n  justify-content: space-between;\n  \n  @media (min-width: 576px) {\n    justify-content: flex-end;\n    gap: 16px;\n  }\n}\n\n.formItem {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  \n  @media (min-width: 576px) {\n    flex-direction: row;\n    align-items: center;\n  }\n\n  label {\n    white-space: nowrap;\n    text-align: left;\n    flex-shrink: 0;\n\n    @media (min-width: 576px) {\n      min-width: 100px;\n    }\n\n    @media (min-width: 992px) {\n      min-width: 1px;\n    }\n  }\n\n  :global(.ant-form-item) {\n    width: 100%;\n    margin-bottom: 0;\n  }\n}\n\n.headerText {\n\tdisplay: block;\n\tfont-weight: 500;\n}\n\n.reportTitle {\n  padding-top: 20px;\n}\n\n.reportFormItem {\n  & :global(.ant-form-item-row) {\n    width: 100%;\n  }\n}\n\n.buttonsHolder {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.inlineFormItem {\n  & > :global(.ant-row) {\n    flex-direction: column;\n    \n    @media (min-width: 576px) {\n      flex-direction: row !important;\n      flex-wrap: nowrap;\n      align-items: center;\n      gap: 16px;\n    }\n  }\n\n  & :global(.ant-form-item-label) {\n    flex-shrink: 0;\n  }\n}\n\n.uploadCsv {\n  & :global(.ant-form-item-control-input-content) {\n    flex: 0;\n  }\n}\n\n.stepsHolder {\n  display: flex;\n  gap: 20px;\n  padding-bottom: 20px;\n  margin-bottom: 20px;\n  flex-direction: column;\n\n  @media (min-width: 1024px) {\n    flex-direction: row;\n  }\n}\n\n.stepItem {\n  flex: 0 1 auto;\n  position: relative;\n  display: flex;\n  text-align: left;\n  gap: 8px;\n\n  &:not(:last-child) {\n    &::after {\n      content: '';\n      position: absolute;\n      display: block;\n      width: 8px;\n      height: 16px;\n      bottom: 0;\n      left: 50%;\n      transform: rotate(90deg) translateX(-50%);\n      font-size: 30px;\n      background-image: url(\"data:image/svg+xml,%3Csvg width='10' height='17' viewBox='0 0 10 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 0.5L9 8.5L1 16.5' stroke='black' stroke-opacity='0.25'/%3E%3C/svg%3E%0A\");\n      background-repeat: no-repeat;\n      background-position: center center;\n      background-size: contain;\n\n      @media (min-width: 1024px) {\n        top: 50%;\n        left: auto;\n        right: -17px;\n        transform: rotate(0) translate(0, -50%);\n      }\n    }\n  }\n\n  &.current {\n    .stepNumber {\n      background-color: #1890FF;\n      border-color: #1890FF;\n      color: #fff;\n    }\n  }\n\n  &.future {\n    opacity: 0.45;\n  }\n\n  &.past:not(.withError) {\n    opacity: 0.45;\n    .stepNumber {\n      background-color: #1890FF;\n      color: #fff;\n    }\n\n  }\n\n  &.withError {\n    .stepNumber {\n      text-indent: -9999999px;\n\n      background-image: url(\"data:image/svg+xml,%3Csvg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7.0914 5.99919L11.7789 0.411694C11.8575 0.318836 11.7914 0.177765 11.67 0.177765H10.245C10.161 0.177765 10.0807 0.215265 10.0253 0.279551L6.15926 4.88848L2.29319 0.279551C2.23962 0.215265 2.15926 0.177765 2.07355 0.177765H0.648547C0.527118 0.177765 0.461047 0.318836 0.539618 0.411694L5.22712 5.99919L0.539618 11.5867C0.522017 11.6074 0.510726 11.6327 0.507084 11.6596C0.503442 11.6866 0.507602 11.714 0.519071 11.7386C0.53054 11.7632 0.548836 11.784 0.571786 11.7986C0.594737 11.8131 0.621378 11.8208 0.648547 11.8206H2.07355C2.15748 11.8206 2.23783 11.7831 2.29319 11.7188L6.15926 7.10991L10.0253 11.7188C10.0789 11.7831 10.1593 11.8206 10.245 11.8206H11.67C11.7914 11.8206 11.8575 11.6796 11.7789 11.5867L7.0914 5.99919Z' fill='%23FF4D4F'/%3E%3C/svg%3E%0A\");\n      background-repeat: no-repeat;\n      background-position: center center;\n      background-size: 12px;\n      border-color: #FF4D4F;\n    }\n\n    .stepText {\n      opacity: 0.45;\n    }\n  }\n\n  @media (min-width: 576px) {\n    padding: 0 40px 20px 0;\n  }\n\n  @media (min-width: 1024px) {\n    padding: 0 40px;\n  }\n}\n\n.stepNumber {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #000;\n  flex-shrink: 0;\n} \n\n.stepTitle {\n  font-size: 16px;\n  line-height: 1.5;\n  margin: 4px 0;\n  font-weight: normal;\n}\n\n.stepText {\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.upload {\n  display: flex;\n}\n\n.uploadCsv {\n  & :global(.ant-upload) {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 8px;\n\n    @media (min-width: 576px) {\n      flex-direction: row;\n    }\n\n    & a {\n      white-space: nowrap;\n      font-weight: 500;\n    }\n  }\n}\n\n.previewFileName {\n  display: flex;\n  gap: 5px;\n  margin-bottom: 10px;\n\n  & svg {\n    fill: rgba(0, 0, 0, 0.45);\n  }\n\n  & :global(.anticon) {\n    flex-shrink: 0;\n  }\n\n  & .fileName {\n    color: #1890FF;\n  }\n}\n\n.importTable {\n  & table {\n    min-width: 1180px !important;\n  }\n\n  & :global(.ant-table-cell) {\n    & :global(.ant-table-column-title) {\n      white-space: nowrap;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"previewTable": `Report_previewTable__+98VX`,
	"headerText": `Report_headerText__Lta6D`,
	"actionIcon": `Report_actionIcon__AHqCi`,
	"actionsWrapper": `Report_actionsWrapper__eYcO9`,
	"formItem": `Report_formItem__AVISn`,
	"reportTitle": `Report_reportTitle__3oFxM`,
	"reportFormItem": `Report_reportFormItem__ylDGF`,
	"buttonsHolder": `Report_buttonsHolder__aSbOr`,
	"inlineFormItem": `Report_inlineFormItem__wvsFs`,
	"uploadCsv": `Report_uploadCsv__5QV9h`,
	"stepsHolder": `Report_stepsHolder__lWSzh`,
	"stepItem": `Report_stepItem__E7eq-`,
	"current": `Report_current__fBpFV`,
	"stepNumber": `Report_stepNumber__BJO-k`,
	"future": `Report_future__U-l+v`,
	"past": `Report_past__47nPY`,
	"withError": `Report_withError__8XVAK`,
	"stepText": `Report_stepText__abbfG`,
	"stepTitle": `Report_stepTitle__+0zlS`,
	"upload": `Report_upload__r969-`,
	"previewFileName": `Report_previewFileName__EHc-z`,
	"fileName": `Report_fileName__iOnAU`,
	"importTable": `Report_importTable__jSKMm`
};
export default ___CSS_LOADER_EXPORT___;
